import { inject, InjectionKey, provide, Ref, ref } from 'vue'
import { CampaignKey } from '@/api/types'
import { ICampaignAttributes } from '@/apps/traforama/interfaces/campaigns'

import { useCampaignsStore } from '@/apps/traforama/store/campaigns'

const useFetchCampaign = () => {
  const campaignsStore = useCampaignsStore()
  const campaign = ref<ICampaignAttributes | undefined>(undefined)
  const fetchingCampaign = ref(true)

  function fetchCampaign(id: string, skipId?: boolean): void {
    campaignsStore.FetchItem(id).then(() => {
      const storedItem = campaignsStore.itemById(id)
      fetchingCampaign.value = false
      if (storedItem !== undefined && storedItem !== null) {
        if (skipId) {
          delete storedItem['id']
          campaign.value = { ...storedItem } as ICampaignAttributes
        } else {
          campaign.value = storedItem as ICampaignAttributes
        }
      }
    })
  }

  const provideCampaign = function () {
    provide(CampaignKey, campaign)
    return campaign
  }

  const injectCampaign = function () {
    return inject(CampaignKey)
  }

  return {
    campaign,
    fetchingCampaign,
    fetchCampaign,
    provideCampaign,
    injectCampaign
  }
}

export default useFetchCampaign
